import React from 'react';
import { ImageMarkup, LoadingSpinner } from 'yankees-react-utils';
import { BarrelBox as BarrelBoxApi, useOktaQuery } from '../../../../data';
import StrikeZoneRhh from '../../../../images/strike-zone-rhh.png';
import StrikeZoneLhh from '../../../../images/strike-zone-lhh.png';

const DEFAULT_HEIGHT = 315;
const DEFAULT_WIDTH = 272;

const BarrelBox = ({ pitcherId, isLhh, order, levelId }) => {
    const { data: barrelBox, isLoading } = useOktaQuery(
        ['barrelBox', pitcherId, isLhh, order, levelId],
        (t) => BarrelBoxApi.query(t, { pitcherId, isLhh, order, levelId }),
    );

    const firstBarrelBox = barrelBox?.length ? barrelBox[0] : null;
    const height = firstBarrelBox?.Height ?? DEFAULT_HEIGHT;
    const width = firstBarrelBox?.Width ?? DEFAULT_WIDTH;

    if (isLoading) return <div className="py-5 text-center"><LoadingSpinner /></div>;

    return (
        <div key={`${pitcherId}-${isLhh}-${order}-${levelId}`}>
            <ImageMarkup
                height={height}
                width={width}
                initialElements={barrelBox.length ? JSON.parse(barrelBox[0].Markup) : []}
                backgroundImage={isLhh ? StrikeZoneLhh : StrikeZoneRhh}
            />
        </div>
    );
};

export default BarrelBox;
